import type { TrialGateInput, TrialMembershipSnapshot } from "./types";

/** 从同一份会员快照派生当前档位与同档状态，供展示、点击和下单前复核共用。 */
export function buildTrialGate(
  target: Pick<TrialGateInput, "packageKey" | "monthSubscribe">,
  user: TrialMembershipSnapshot
): TrialGateInput {
  const activePackageKey = user.isMemberUser ? user.highestPackage : "free";
  return {
    ...target,
    activePackageKey,
    sameTierActive: activePackageKey === target.packageKey,
    trialTier: user.trialTier,
    currentActiveTrial: user.currentActiveTrial,
    expiryHistory: user.expiryHistory
  };
}
